import Calculator from '@/pages/Tax/Calculator'
import BatchUpload from '@/pages/Tax/BatchUpload'
import BatchResult from '@/pages/Tax/BatchResult'

export default [
    {
        path: '',
        redirect: 'calculator'
    },
    {
        path: 'calculator',
        component: Calculator
    },
    {
        path: 'batch',
        component: BatchUpload
    },
    {
        path: 'batch/result',
        component: BatchResult
    }
]
